import { useMemo, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { categoryTabs, streamItems } from "@/mocks/home";

export default function CategoryStream() {
  const [activeTab, setActiveTab] = useState(categoryTabs[0]);
  const [expanded, setExpanded] = useState(false);

  const filtered = useMemo(() => {
    if (activeTab === "全部") return streamItems;
    return streamItems.filter((item) => item.category === activeTab);
  }, [activeTab]);

  const visible = expanded ? filtered : filtered.slice(0, 6);
  const hasMore = filtered.length > 6;

  return (
    <section id="stream" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="速看新料"
            tone="accent"
            title="按分区速看，别被无关话题带跑"
            description="每个分区只放同题材的条目，标题在前、摘要在后，点开分区就能快速补课。内容会随着新料上架持续更新。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 inline-flex flex-wrap gap-1 rounded-full border border-background-300 bg-background-50 p-1">
            {categoryTabs.map((tab) => {
              const active = tab === activeTab;
              return (
                <button
                  key={tab}
                  type="button"
                  onClick={() => {
                    setActiveTab(tab);
                    setExpanded(false);
                  }}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700"
                  }`}
                >
                  {tab}
                </button>
              );
            })}
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {visible.map((item, index) => (
            <Reveal key={item.title} delay={index * 50}>
              <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800">
                    {item.category}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-600">
                    <i className="ri-price-tag-3-line" />
                    {item.source}
                  </span>
                </div>
                <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-accent-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="clamp-3 mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line" />
                    {item.time}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-700 transition-colors group-hover:text-accent-700">
                    进入讨论
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-10 rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center text-sm text-foreground-500">
            这个分区暂时还没有新料，换个分区看看？
          </p>
        )}

        {hasMore && (
          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-700"
            >
              <i className={expanded ? "ri-arrow-up-line" : "ri-add-line"} />
              {expanded ? "收起部分条目" : `展开更多 ${filtered.length - 6} 条新料`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}